import AddressGeoApi from 'components/AddressGeoApi/AddressGeoApi';

const LocationSection = ({
  address,
  setAddress,
  dataCreateMission,
  setDataCreateMission,
  hideTitle,
}) => {
  const onAddressChange = (addr) => {
    setAddress(addr);
    setDataCreateMission((prev) => ({
      ...prev,
      location: addr,
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      {hideTitle ? null : <div className="text-xl">Lieu</div>}
      <AddressGeoApi
        label={<span className="sr-only">Adresse</span>}
        addressGeoValue={onAddressChange}
        addressValue={address}
        isAddressCompany={dataCreateMission?.idLocation || null}
        page={'adminMissionCreation'}
      />
    </div>
  );
};

export default LocationSection;
